'use client';

import {useEffect} from 'react';

// useCloseOnEscape calls onEscape whenever the Escape key is pressed. No-ops
// when onEscape is undefined (e.g. a non-dismissable modal). Re-binds if the
// callback identity changes, so pass a stable handler to avoid churn.
export function useCloseOnEscape(onEscape: (() => void) | undefined): void {
  useEffect(() => {
    if (!onEscape) return;
    function handleKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onEscape!();
    }
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onEscape]);
}
